// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"b55b2796","576":"94e71c50","898":"addd1244"}[chunkId] + ".chunk.js";
};